export default "20260423.1 \r\n"